import React from 'react';
import { Link } from 'react-router-dom';
import { ScrollAnimate } from '../components/ScrollAnimate';
import { SEO } from '../components/SEO';
import { blogPosts } from '../data/blogPosts';

export function BlogPage() {
  return (
    <>
      <SEO
        title="Blog & Resources — logNsec"
        description="Threat intelligence, financial security, and risk insights for SMEs and teams building resilience in emerging markets."
        canonical="/blog"
      />
      <section className="bg-[#F5F5F5] px-5 py-20 text-center md:px-8 md:py-24">
        <div className="mx-auto max-w-3xl">
          <ScrollAnimate>
            <p className="text-label-site text-[#65676B]">Resources</p>
            <h1 className="text-section mt-3">
              Blog &amp; Insights
            </h1>
            <p className="mx-auto mt-6 max-w-[560px] text-body-site">
              Practical guidance on threats, mobile-money risk, and what a security incident really costs—written for
              growing businesses and security-minded teams.
            </p>
          </ScrollAnimate>
        </div>
      </section>

      <section className="bg-white px-5 py-16 md:px-8 md:py-20">
        <div className="mx-auto max-w-7xl">
          <ScrollAnimate>
            <div className="grid grid-cols-1 items-stretch gap-6 md:grid-cols-2 lg:grid-cols-3">
              {blogPosts.map((post) => (
                <article key={post.id} className="card-site flex h-full flex-col">
                  <span className="inline-flex w-fit rounded-full bg-[#E7F0FF] px-3 py-1 text-xs font-semibold text-[#0064E0]">
                    {post.category}
                  </span>
                  <h2 className="text-card-title mt-5">{post.title}</h2>
                  <p className="mt-4 flex-1 text-body-site">{post.excerpt}</p>
                  <p className="mt-6 text-sm text-[#65676B]">
                    {post.date}
                    <span className="mx-2 text-[#E4E6EB]">·</span>
                    {post.readTime}
                  </p>
                  <Link
                    to={`/blog/${post.slug}`}
                    className="mt-auto pt-8 text-base font-semibold text-[#0064E0] hover:underline"
                  >
                    Read Article →
                  </Link>
                </article>
              ))}
            </div>
          </ScrollAnimate>
        </div>
      </section>
    </>
  );
}
